import React from 'react'
import { successtick } from "../../constants/Images";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
export default function Joinsuccess() {
    const [auctionname, setAuctionname] = useState(localStorage.getItem('cjoined'))
    return (
        <div className='joinsuccess'>
            <div>        <h3>You have successfully joined <span className='sucauc'>{auctionname}</span> </h3></div>
            <div>        <img src={successtick} alt="" /> </div>
            {localStorage.getItem('user') &&
            <div className='joinback' ><Link to='/dashboard'><button className='joinbackbtn'>Go to Dashboard</button></Link></div>
            }
            {/* <button>Back</button> */}
        </div>
    )
}
